import * as yup from 'yup';

export const usePersonalHealthStepFormSchema = () => {
  const schema = yup.object({
    beenDiagnosed: yup.string().required('This field is required'),
    diagnoseDetails: yup.string().when('beenDiagnosed', {
      is: (beenDiagnosed: any) => beenDiagnosed === '1',
      then: (yupSchema) => yupSchema.required('This field is required'),
    }),
    doctorName: yup.string().required('Name is a required field'),
    doctorAddress: yup.string().required('Address is a required field'),
    doctorPostcode: yup.string().required('Postcode is a required field'),
    doctorPhone: yup.string().required('Phone number is a required field'),
    doctorEmail: yup.string().required('Email is a required field'),
    previousGPList: yup.array().of(
      yup.object().shape({
        doctorName: yup.string(),
        doctorAddress: yup.string(),
        doctorPostcode: yup.string(),
        doctorPhone: yup.string(),
        doctorEmail: yup.string(),
      }),
    ),
    anyPeriodsGP: yup.string().required('This field is required'),
    periodsAdditionalInfo: yup.string().when(['anyPeriodsGP'], {
      is: (anyPeriodsGP: any) => anyPeriodsGP === '1',
      then: (yupSchema) => yupSchema.required('This field is required'),
    }),
  });

  return { schema };
};
